import { render, staticRenderFns } from "./layer.vue?vue&type=template&id=aed80256&"
import script from "./layer.vue?vue&type=script&lang=ts&"
export * from "./layer.vue?vue&type=script&lang=ts&"
import style0 from "./layer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports